import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import HeartIcon from '../../../assets/Player_Portal/images/heart-Icon.png';
import SkewCard from '../../../assets/Player_Portal/images/card-skew.png';
import CornerCircle from '../../../assets/Player_Portal/images/circle-corner.png';
import showPassword from '../../../assets/images/showPwrd.svg'
import hidePassword from '../../../assets/images/hidePwrd.svg'
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import orIcon from "../../../assets/Player_Portal/images/oR_img.png"
import Google from "../../../assets/Player_Portal/images/google_icon.png"
import Facebook from "../../../assets/Player_Portal/images/fb_icon.png"
import Instagram from "../../../assets/Player_Portal/images/insta_icon.png"
import Twitter from "../../../assets/Player_Portal/images/twitter_icon.png"
import { useUserLoginMutation } from '../../../features/UserFeatures/UserLoginSlice/UserLoginApiSlice';
import Loader from '../../../components/Loader/Loader';
import Swal from 'sweetalert2';
import { useVerifyMailMutation } from '../../../features/UserFeatures/VerifyMail/VerifyMailSlice';

const Login = () => {
const navigate = useNavigate()
  const [userLoginData] = useUserLoginMutation()
  const [showHidePwrd, setShowHidePwrd] = useState(false);
  const [resendBtn, setResendBtn] = useState(false);
  const [loading, setLoading] = useState(false)
  const { register, handleSubmit, formState: { errors }, reset } = useForm()


  const token = localStorage.getItem("token")
  useEffect(() => {
    if (token) {
      navigate('/')
    }
  }, [])

 

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      // console.log("data", data)
      const userLogin = await userLoginData(data)
      // console.log("userLogin", userLogin)
      console.log("userLoginuserLogin", userLogin)
      if (userLogin?.data?.status === 200) {
        localStorage.setItem("token", userLogin?.data?.data?.token)
        localStorage.setItem("emailId", userLogin?.data?.data?.email)
        localStorage.setItem("userName", userLogin?.data?.data?.userName)
        localStorage.setItem("userId", userLogin?.data?.data?.id)
        reset({ email: "", password: "" })
        navigate('/')
        Swal
          .fire({
            title: 'Success!',
            type: 'Success',
            text: userLogin?.data?.message
          });
      }
      else {
        Swal
          .fire({
            title: 'Oops!',
            type: 'error',
            // text: userLogin?.data?.message
            text: userLogin?.data?.message
          });
        }
        setResendBtn(true)
      setShowHidePwrd(false)
    }
    catch (err) {
      Swal
        .fire({
          title: 'error',
          type: 'error',
          text: 'something went wrong ! try again'
        });
    }
    setLoading(false)
  }

  return (

    <div className='formWrapper'>
      {loading && <Loader />}
      <Container fluid className='h-100'>
        <Row className='h-100'>
          <Col md={5} lg={6} xl={7} className='loginBg p-0'>
            <div className='d-flex flex-column justify-content-between h-100'>
              <div className='text-end'>
                <img src={HeartIcon} />
              </div>
              <div className='text-start'>
                <img src={SkewCard} />
              </div>
              <div className='text-start'>
                <img src={CornerCircle} />
              </div>
            </div>
          </Col>
          <Col md={7} lg={6} xl={5}>
            <div className='loginForm'>

              <form onSubmit={handleSubmit(onSubmit)} className="form-md">
                <h1 className='loginHead text-start'>Login</h1>
                <h4 className='welcomeText text-start'>Welcome Back!</h4>
                <p className='loginPara text-start'>Enter your email address and password to login.</p>
                <div className="form-group">
                  <input
                    id="email" onInput={(e)=> e.target.value=e.target.value.trim()} type="text" placeholder='username/email' {...register("email", { required: "*Enter email.", pattern: { value: /\S+@\S+\.\S+/, message: "Entered value does not match email format.", } })}
                    autoFocus />
                  <span className='inputIcon'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24.718" height="17.725" viewBox="0 0 25.718 20.725">
                      <path id="mail-svgrepo-com" d="M23.978,6.74c-1.8-1.628-4.838-2.24-9.619-2.24S6.542,5.112,4.74,6.74m19.238,0c1.616,1.46,2.24,3.737,2.24,7.122,0,7.159-2.79,9.362-11.859,9.362S2.5,21.022,2.5,13.862c0-3.385.624-5.662,2.24-7.122m19.238,0-7.853,7.853a2.5,2.5,0,0,1-3.531,0L4.74,6.74" transform="translate(-1.5 -3.5)" fill="none" stroke="#989898" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                    </svg>
                  </span>
                  {/* <label className='customLabel' htmlFor="email">email</label> */}
                  {errors.email && <span role="alert">{errors.email.message}</span>}
                </div>
                <div className="form-group mb-2">

                  <input
                    id="password" onInput={(e)=> e.target.value=e.target.value.trim()} type={showHidePwrd ? "text" : "password"} placeholder='Password'{...register("password", { required: "*Enter password.", minLength: { value: 5, message: "Minimum length is 5." } })}
                  />
                  <span className='inputIcon'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20.392" height="18.227" viewBox="0 0 21.392 21.227">
                      <path id="lock-svgrepo-com" d="M7.636,10.507c.571-.031,1.276-.031,2.182-.031h7.757c.906,0,1.61,0,2.182.031m-12.12,0a4.558,4.558,0,0,0-1.651.319,3.451,3.451,0,0,0-1.589,1.4C4,12.912,4,13.809,4,15.6v1.5c0,1.795,0,2.692.4,3.377a3.451,3.451,0,0,0,1.589,1.4c.778.349,1.8.349,3.832.349h7.757c2.036,0,3.054,0,3.832-.349A3.451,3.451,0,0,0,23,20.476c.4-.686.4-1.583.4-3.377V15.6c0-1.795,0-2.692-.4-3.377a3.451,3.451,0,0,0-1.589-1.4,4.558,4.558,0,0,0-1.651-.319m-12.12,0V8.34C7.636,5.391,10.349,3,13.7,3s6.06,2.391,6.06,5.34v2.167" transform="translate(-3 -2)" fill="none" stroke="#989898" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                    </svg>

                  </span>

                  <span className='showHide' onClick={() => { setShowHidePwrd(!showHidePwrd) }}>
                    <img src={showPassword} className={showHidePwrd ? "d-none" : "d-block"} alt="Show Password" />
                    <img src={hidePassword} className={showHidePwrd ? "d-block" : "d-none"} alt="Hide Password" />
                  </span>
                  {/* <label className='customLabel' htmlFor="password">password</label> */}
                  {errors.password && <span role="alert">{errors.password.message}</span>}
                </div>
                <div className='form-group d-flex align-items-center justify-content-end'>
                  <label htmlFor="remember_me" className='text-muted d-flex align-items-center visually-hidden'>
                    <input type="checkbox" value="rememberMe" id="remember_me" className='me-2' {...register("rememberMe")} />
                    Remember me
                  </label>
                  {/* <Link className='text-decoration-none' to="/resend_verificationLink">Resend Mail</Link> */}
{resendBtn ? <Link to="/resend_verificationLink" className='text-decoration-none forgotPwrd'>Resend Verification Link</Link> :
<Link to="/forgotPassword" className='text-decoration-none forgotPwrd'>Forgot Password?</Link>}
                </div>
                <button className='btn btnSubmit' type="submit">LOGIN</button>

                <div className='text-center'>
                  <img src={orIcon} className='my-3' alt="Or" />
                  <p className='continueText'>or continue with</p>
                  <ul className='socialLogin d-flex justify-content-center list-unstyled socialLogin'>
                    <li>
                      <Link to=''>
                        <img src={Google} alt="" />
                      </Link>
                    </li>
                    <li><Link to=''>
                      <img src={Facebook} alt="" />
                    </Link>
                    </li>
                    <li><Link to=''>
                      <img src={Instagram} alt="" />
                    </Link>
                    </li>
                    <li>
                      <Link to=''>
                        <img src={Twitter} alt="" />
                      </Link>
                    </li>
                  </ul>

                </div>
              </form>

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Login;
